import React from 'react';
import { Navbar } from '../components/Navbar';
import { AboutPage } from '../components/AboutPage';
import { Footer } from '../components/Footer';
export const About = () => {
  return <div className="font-sans text-gray-800 bg-white" data-id="element-2329" data-mp="29jvnve1hclrx">
      <Navbar data-id="element-2330" data-mp="29lgguz85bwno" />
      <AboutPage data-id="element-2331" data-mp="29hixqdlkj53s" />
      <Footer data-id="element-2332" data-mp="2eiq5wdrmi6az" />
    </div>;
};